// extracted by mini-css-extract-plugin
export default {"select-wrapper":"Dropdown_select-wrapper__U3hYk","label":"Dropdown_label__lksqM","disabled":"Dropdown_disabled__kUn7r","noBorder":"Dropdown_noBorder__APkJL"};